import { isUndefined } from 'lodash';

import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';
import { StandardSpinner } from '@dreryk/react-components';

import { usePreInterviewGlobalState } from '../../PreInterviewResolver.hooks';

import { PreInterviewCreateLink } from './PreInterviewCreateLink';
import { PreInterviewPreviewLink } from './PreInterviewPreviewLink';
import { PreInterviewUpdateLink } from './PreInterviewUpdateLink';

type PreInterviewCellProps = {
   readonly appointmentId: number;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientId: number;
   readonly patientFullName: string;
   readonly visitId: number | undefined;
   readonly visitStatus: VisitAndAppointmentStatus;
};

export const PreInterviewCell = (props: PreInterviewCellProps): JSX.Element => {
   const { getPreInterviewState } = usePreInterviewGlobalState();
   const preInterviewState = getPreInterviewState(props.appointmentId);

   if (isUndefined(preInterviewState)) {
      return <StandardSpinner />;
   }

   switch (preInterviewState?.status) {
      case 'STARTED': {
         return (
            <PreInterviewUpdateLink
               appointmentId={props.appointmentId}
               beginDate={props.beginDate}
               endDate={props.endDate}
               patientFullName={props.patientFullName}
               surveyId={preInterviewState.surveyId}
            />
         );
      }
      case 'CLOSED':
      case 'APPROVED': {
         return (
            <PreInterviewPreviewLink
               appointmentId={props.appointmentId}
               beginDate={props.beginDate}
               endDate={props.endDate}
               patientFullName={props.patientFullName}
               patientId={props.patientId}
               visitId={props.visitId}
               visitStatus={props.visitStatus}
            />
         );
      }
      case null:
      case undefined:
      case 'INITIALIZED':
      case 'EXPIRED':
         return (
            <PreInterviewCreateLink
               appointmentId={props.appointmentId}
               beginDate={props.beginDate}
               endDate={props.endDate}
               patientFullName={props.patientFullName}
               disabled={preInterviewState?.status === 'EXPIRED'}
            />
         );
      default: {
         return assertUnreachable(preInterviewState?.status);
      }
   }
};
